import { AxiosResponse } from 'axios'
import apiClient from 'api/common/common'
import { LoginRequest } from 'api/common/requests'
import { LoginResponse } from 'api/common/responses'
import { Status } from 'api/common/statuses'
import loginData from 'utilities/loginData'

/**
 * ログインAPI
 * @param request
 * @param callback
 */
const loginAPI = async (request: LoginRequest, callback: (status: Status, nextScene: string | null) => void) => {
  await apiClient
    .post('/login', request)
    .then((response: AxiosResponse<LoginResponse>) => {
      const status = response?.headers['x-aqc-status'] ?? 'failed'
      if (status === Status.Success) {
        loginData.setResponse(response.data)
      }
      callback(status, loginData.getLoggedInScene())
    })
    .catch((error) => {
      console.error(error)
    })
}

export default loginAPI
